<template>
  <div class="course-module">
    <h-section-header :back="'/coach-courses/' + module.course">
        Edit Module
    </h-section-header>
    <div class="card card--white">
      <div class="card card--container">
        <h-input type="text" required label="Title of Module" v-model="module.title" outline />
        <h-input type="text" label="Description of Module" v-model="module.description" required outline/>
        <h-input type="checkbox" :reverse="true" label="Published" v-model="module.published"/>

        <v-alert :value="displayError" type="error">{{displayError}}</v-alert>
        <v-alert :value="missingRequiredFields" type="error">{{missingRequiredFields}}</v-alert>
        <h-btn @click="saveModule" color="primary">Save</h-btn>
        <button v-if="module.id" class="right btn" @click="showDeleteDialog = true">
          <span class="hide-at-xs">Delete Module</span>
          <i class="material-icons hide-gt-xs">delete</i>
        </button>
      </div>
    </div>
    <div v-if="module.id">
      <h-section-header >
        <div class="row space-between align-center full-width">
          <div>Lessons</div>
          <h-icon class="clickable" @click="exercises.push({})" v-if="module.id">add</h-icon>
        </div>
      </h-section-header>
      <div v-for="(exercise, index) in sortedExercises"
            :key="exercise.id" 
            class="card card--white small-top">
        <div class="card card--container row">
          <div class="col">
            <h-icon :disabled="index == 0" @click="changeOrder(exercise, -1)">ic_keyboard_arrow_up</h-icon>
            <h-icon :disabled="index == sortedExercises.length - 1" @click="changeOrder(exercise, 1)"> ic_keyboard_arrow_down </h-icon>
          </div>
          <lesson :id="exercise.id" :ordering="index" @deleted="deleteExercise" @post="addExercise"
                    @exerciseSaved="$emit('draftSaved')"/>
        </div>
      </div>
    </div>
    <v-dialog v-model="showDeleteDialog" max-width="500px">
      <div class="card card--white">
        <div>
          <span>Are you sure?</span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <h-btn slot="activator" icon>
              <h-icon>more_vert</h-icon>
            </h-btn>
            <v-list>
              <!--<v-list-tile v-for="(item, i) in items" :key="i" @click="">-->
                <!--<v-list-tile-title>{{ item.title }}</v-list-tile-title>-->
              <!--</v-list-tile>-->
            </v-list>
          </v-menu>
        </div>
        <div>
          <h-btn color="primary" flat @click.stop="showDeleteDialog=false">Close</h-btn>
          <h-btn color="red" flat @click.stop="showDeleteDialog=false; deleteModule()">Delete</h-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dataStore from "@/services/api/store";
import lesson from "./lesson";
import snackbarHub from "@/services/hubs/snackbar";
const COURSE_MODULE_STORE = "CoachCourseModules";
const MODULE_LESSON_STORE = "CoachModuleLessons";

export default {
  props: ["module", "moduleId", "displayError"],
  created() {
    this.exerciseTypes = ["file", "video"];
    if (this.moduleId) {
      dataStore
        .findAll(MODULE_LESSON_STORE, { limit: 500, module: this.moduleId })
        .then(r => {
          this.exercises = r;
        });
    }
  },
  computed: {
    sortedExercises() {
      return _.orderBy(this.exercises, "ordering");
    }
  },
  data: function() {
    return {
      showDeleteDialog: false,
      missingRequiredFields: false,
      exercises: []
    };
  },
  methods: {
    saveModule() {
      if (!this.module.title) {
        this.missingRequiredFields = "Title is required";
        return;
      }
      if (!this.module.description) {
        this.missingRequiredFields = "Description is required";
        return;
      }
      this.$emit("save", this.module);
    },
    addExercise(exercise) {
      this.exercises.push(exercise);
      this.exercises = this.exercises.filter(ex => ex.id);
    },
    changeOrder(exercise, add) {
      let sorted = _.orderBy(this.exercises, "ordering");
      let index = sorted.indexOf(exercise);
      let first = sorted[index + add];
      first.ordering = index;
      exercise.ordering += add;
      let update = exercise => {
        dataStore.update(
          MODULE_LESSON_STORE,
          exercise.id,
          { ordering: exercise.ordering },
          { method: "patch" }
        );
      };
      Promise.all([update(first), update(exercise)]).then(() => {
        snackbarHub.update("Saved");
      });
    },
    deleteExercise(lesson) {
      this.exercises.filter(l => l.ordering > lesson.ordering).map(l => {
        l.ordering -= 1;
        l.save();
      });
      this.exercises = this.exercises.filter(
        exercise => lesson.id !== exercise.id
      );
    },
    deleteModule() {
      dataStore.destroy(COURSE_MODULE_STORE, this.module.id);
      this.$router.push({
        name: "courseDetail",
        params: { id: this.module.course }
      });
    }
  },
  components: {
    lesson
  }
};
</script>
